import { configureStore } from "@reduxjs/toolkit";
import scholarshipReducer from "../states/reducers/scholarshipReducer";
import internshipReducer from "../states/reducers/internshipReducer";
import trainingReducer from "../states/reducers/trainingReducer";
import jobsReducer from "../states/reducers/jobsReducer";
import feedbackReducer from "../states/reducers/feedbackReducer";
import statsticsReducer from "../states/reducers/statsticsReducer";
import userReducer from "../states/reducers/userReducer";
import dataReducer from "../states/reducers/dataSilence";
import loginReducer from "../states/reducers/logingReducer";
import newsReducer from "../states/reducers/newsReducer";
import appointmentReducer from "../states/reducers/appointmentReducer";
import donateReducer from "../states/reducers/donateReducer";
import teamsReducer from "../states/reducers/teamsReducer";
import resourceReducer from "../states/reducers/resourcesReducer";
import testimonialReducer from "../states/reducers/testimonialsReducer";
import partnersReducer from "../states/reducers/partnersReducer";
import googleResponseReducer from "../states/reducers/googleResponseReducer";
const store = configureStore({
  reducer: {
    feedback: feedbackReducer,
    appointment: appointmentReducer,
    statstics: statsticsReducer,
    scholarships: scholarshipReducer,
    internships: internshipReducer,
    training: trainingReducer,
    jobs: jobsReducer,
    users: userReducer,
    data: dataReducer,
    userLogin: loginReducer,
    News: newsReducer,
    donate: donateReducer,
    teams: teamsReducer,
    resources: resourceReducer,
    testimonials: testimonialReducer,
    partners: partnersReducer,
    googleformresponse: googleResponseReducer,
  },
});

export default store;
